import { errorLogService } from '../services/errorLogService';

// ============================================
// DETECÇÃO DE EXTENSÕES DE BROWSER
// ============================================

/**
 * Detecta extensões de browser ativas que são conhecidas por modificar o DOM
 * e causar o erro "removeChild" no React.
 *
 * Retorna array com os nomes das extensões detectadas via assinaturas DOM/globais.
 * Se nenhuma for identificada, retorna array vazio.
 */
export function detectActiveExtensions() {
  const detected = [];

  try {
    // Google Translate (injeta class na tag <html>)
    if (
      document.documentElement.classList.contains('translated-ltr') ||
      document.documentElement.classList.contains('translated-rtl')
    ) {
      detected.push('Google Translate');
    }

    // Microsoft Edge Translator (adiciona atributo _msttexthash no <title>)
    if (document.querySelector('title[_msttexthash]')) {
      detected.push('Microsoft Edge Translator');
    }

    // Grammarly (injeta custom element ou atributos data-gramm)
    if (
      document.querySelector('grammarly-extension') ||
      document.querySelector('grammarly-desktop-integration') ||
      document.querySelector('[data-gramm]')
    ) {
      detected.push('Grammarly');
    }

    // LastPass (injeta spans com id __lpform_ ou window.__lpobj__)
    if (
      window.__lpobj__ ||
      document.querySelector('span[id^="__lpform_"]') ||
      document.querySelector('[data-lastpass-icon-root]')
    ) {
      detected.push('LastPass');
    }

    // Honey / PayPal Honey (injeta #honey-container ou window.honey)
    if (
      window.honey ||
      document.getElementById('honey-container')
    ) {
      detected.push('Honey');
    }

    // Tradutores genéricos que envolvem TextNodes em <font> (TransOver, 3CX, etc.)
    // Heurística: presença de <font> filhos diretos de qualquer elemento do app
    const fontEls = document.querySelectorAll('#root font');
    if (fontEls.length > 0) {
      detected.push('Tradutor de página (extensão desconhecida)');
    }
  } catch (e) {
    // Falha silenciosa — a detecção nunca deve impedir o fluxo principal
  }

  return detected;
}

/**
 * Inicializa o sistema de logging de erros do frontend
 * Sobrescreve console.error e capture global errors
 */
export function initializeErrorLogging() {
  // Os hooks globais (override de console.error, window 'error', 'unhandledrejection' e o
  // patch de Node.removeChild) agora são providos pelo script central
  // console-logger.js (incluído no <head> do index.html — o mesmo de todos os apps Agendário).
  // Manter este no-op evita double-logging. `detectActiveExtensions` segue exportada acima
  // porque o ErrorBoundary a usa para enriquecer o contexto enviado via errorLogService.
  console.log('[ErrorLogging] delegado ao console-logger central');
}
